/**
 * Command Queue — 接收意图，按固定 Tick 消费。
 * 队列只暂存命令；验证与执行在 Tick 的 "Consume Commands" 阶段进行。
 */

import type { GameCommand } from '@crater-zero/shared-types';

/** 队列最大长度，超出即拒绝（背压）。 */
export const DEFAULT_MAX_QUEUE = 1024;

export class CommandQueue {
  private readonly items: GameCommand[] = [];
  private readonly maxLength: number;

  constructor(maxLength: number = DEFAULT_MAX_QUEUE) {
    this.maxLength = maxLength;
  }

  /** 入队。超过容量返回 false（调用方应节流/合并）。 */
  enqueue(command: GameCommand): boolean {
    if (this.items.length >= this.maxLength) return false;
    this.items.push(command);
    return true;
  }

  /** 取出本 Tick 要消费的全部命令（按 clientSequence 稳定排序后清空）。 */
  drain(): readonly GameCommand[] {
    const sorted = this.items
      .slice()
      .sort((a, b) => a.clientSequence - b.clientSequence);
    this.items.length = 0;
    return sorted;
  }

  get length(): number {
    return this.items.length;
  }

  clear(): void {
    this.items.length = 0;
  }
}
